import React, { useRef } from 'react';
import './profilecomingsoon.css';
import Layout from '../components/layout';
import profile from '../assets/profile.svg';
import { useGsapAnimations } from '../hooks/useGsapAnimations';

const ProfileComingSoon = () => {
  const pageRef = useRef(null);

  useGsapAnimations(pageRef);

  return (
    <Layout>
      <div className="profile_soon_page" ref={pageRef}>
        <section className="profile_soon_panel" data-gsap-intro>
          <div className="profile_soon_icon">
            <img src={profile} alt="" />
          </div>

          <p>PROFILE</p>
          <h1>Coming soon</h1>
          <span>This feature is not available yet.</span>
        </section>
      </div>
    </Layout>
  );
};

export default ProfileComingSoon;
